import { context } from '@wikia/ad-engine';

export function isEligibleForRender() {
	const experimentPath = 'experiments.floorAdhesionWithBidders';
	const adhesionExperimentConfig = context.get(experimentPath);
	if (adhesionExperimentConfig) {
		/*
		 * ***Note: Apparently calling context.get('experiments.floorAdhesionWithBidders.eligibleForRender')
		 * causes the experiments.floorAdhesionWithBidders to be set to an empty object.
		 * This causes all related logic to the enabling the floor_adhesion to fail.
		 *
		 * We'll just extract the eligibleForRender variable from the experiment config object,
		 * once it's retrieved from the context and if it's not empty.
		 * */
		return adhesionExperimentConfig?.['eligibleForRender'];
	}
}

export function isDesktopFloorAdhesionApplicable() {
	/* Configure the floor_adhesion unit in the following cases:
	 *
	 * There is a floor_adhesion experiment running
	 *	AND the eligibleForRender variable is true
	 * OR
	 * There is no floor_adhesion experiment running (current behavior and floor_adhesion control)
	 */

	const experimentPath = 'experiments.floorAdhesionWithBidders';
	const adhesionExperimentConfig = context.get(experimentPath);
	if (adhesionExperimentConfig) {
		/*
		 * ***Note: Apparently calling context.get('experiments.floorAdhesionWithBidders.eligibleForRender')
		 * causes the experiments.floorAdhesionWithBidders to be set to an empty object.
		 * This causes all related logic to the enabling the floor_adhesion to fail.
		 *
		 * We'll just extract the eligibleForRender variable from the experiment config object,
		 * once it's retrieved from the context and if it's not empty.
		 * */
		return adhesionExperimentConfig?.['eligibleForRender'];
	}

	return true;
}
